import { useEventBus, tryOnScopeDispose } from '@vueuse/core'
import type { SseEventMap } from '~/types/SseMessage'

export function onEvent<K extends keyof SseEventMap>(
  name: K,
  handler: (data: SseEventMap[K]) => void,
) {
  const bus = useEventBus<SseEventMap[K]>(name)
  const unsub = bus.on((event) => {
    try {
      handler(event)
    } catch (e) {
      console.error(`[onEvent] Error in handler for "${name}":`, e)
    }
  })
  tryOnScopeDispose(unsub)
}

export function emitEvent<K extends keyof SseEventMap>(
  name: K,
  data: SseEventMap[K],
) {
  useEventBus<SseEventMap[K]>(name).emit(data)
}
